// Icon (adalicons font glyph) and colour of each workflow phase type.
// Kept separate from PhaseGraph so that it can be used without loading the phase editors.
export const PHASE_TYPE_STYLES = {
  fill: { icon: 'v', color: '#7DAC78' },
  commenting: { icon: '#', color: '#009181' },
  approval: { icon: 'K', color: '#006b99' },
  docusign: { icon: 'A', color: '#007d8f' },
};
